import { render } from "./VerifyTwoFa.vue?vue&type=template&id=6724b72c&scoped=true"
import script from "./VerifyTwoFa.vue?vue&type=script&lang=js"
export * from "./VerifyTwoFa.vue?vue&type=script&lang=js"

import "./VerifyTwoFa.vue?vue&type=style&index=0&id=6724b72c&lang=less&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.20.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6724b72c"]])

export default __exports__